import { Link } from "react-router-dom";

import ASELogo from "../assets/ase-logo.png";
import NavbarLink from "./NavbarLink";

import { Bars3Icon, LifebuoyIcon, UserMinusIcon, ArrowLeftEndOnRectangleIcon, BriefcaseIcon, BuildingOffice2Icon, UsersIcon, SpeakerWaveIcon, UserIcon, PencilIcon, ChevronDownIcon, ClockIcon, UserPlusIcon, QrCodeIcon } from "@heroicons/react/24/outline";
import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { useState } from "react";

const AdminMobileNavOverlay = ({ isOpen, onBroadcastClicked, onCloseClicked }) => {
  const { mutateUser, setToken } = useContext(AuthContext);

  const [isLabourDropdownOpen, setIsLabourDropdownOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken(null);
    mutateUser(null);
  }

  return (
    <nav className={`${isOpen ? 'fixed' : 'hidden'} top-0 left-0 right-0 bottom-0 z-50 bg-white shadow-md md:hidden px-4 py-2`}>
      <div className="flex items-center justify-between mb-8">
        <Link to="/l">
          <img src={ASELogo} alt="ASE Group" className="h-[30px]" />
        </Link>

        <Bars3Icon
          className='h-8 w-8 text-ase-blue'
          onClick={onCloseClicked}
        />
      </div>

      <div className="flex flex-col gap-2 mb-4">
        <NavbarLink to="/admin/design-and-engineering" label="Design & Engineering" icon={<PencilIcon className="h-8 w-8 text-ase-blue" />} end={true} />

        <div className="flex flex-col gap-2">
          <button
            onClick={e => setIsLabourDropdownOpen(!isLabourDropdownOpen)}
            className="text-lg md:text-sm px-2 py-2 md:py-1 flex items-center gap-2 md:gap-2 hover:text-ase-blue transition-all"
          >
            <UsersIcon className="h-8 w-8 text-ase-blue" />
            Labour
            <ChevronDownIcon className="h-8 w-8 text-ase-blue self-end" />
          </button>

          {isLabourDropdownOpen && (
            <div className="flex flex-col gap-2 border-y border-y-ase-blue">
              <NavbarLink to="/admin/projects" label="Projects" icon={<BuildingOffice2Icon className="h-8 w-8 text-ase-blue" />} />
              <NavbarLink to="/admin/labour" label="Labourers" icon={<UsersIcon className="h-8 w-8 text-ase-blue" />} />
              <NavbarLink to="/admin/allocations" label="Allocations" icon={<BriefcaseIcon className="h-8 w-8 text-ase-blue" />} />
              <NavbarLink to="/admin/time-entries" label="Time entries" icon={<ClockIcon className="h-8 w-8 text-ase-blue" />} />
              <NavbarLink to="/admin/leave-requests" label="Leave Requests" icon={<UserMinusIcon className="h-8 w-8 text-ase-blue" />} />
              <NavbarLink to="/admin/potential-hires" label="Potential Hires" icon={<UserPlusIcon className="h-8 w-8 text-ase-blue" />} />
              <NavbarLink to="/admin/clocked-in" label="Clocked In" icon={<QrCodeIcon className="h-8 w-8 text-ase-blue" />} />
            </div>
          )}
        </div>


        <NavbarLink to="/admin/support" label="Support" icon={<LifebuoyIcon className="h-8 w-8 text-ase-blue" />} />
        <NavbarLink to="/admin/profile" label="Profile" icon={<UserIcon className="h-8 w-8 text-ase-blue" />} />

        <button
          onClick={onBroadcastClicked}
          className={`text-lg md:text-sm px-2 py-2 md:py-1 flex items-center gap-2 md:gap-1 hover:text-ase-blue transition-all`}
        >
          <SpeakerWaveIcon
            className="h-8 w-8 text-ase-blue cursor-pointer"
          />

          Broadcast
        </button>
      </div>

      <button
        onClick={handleLogout}
        className='bg-red-600 text-white font-semibold h-[36px] rounded-md w-[250px] flex items-center justify-center gap-1 text-sm'
      >
        <ArrowLeftEndOnRectangleIcon className='h-5 w-5' /> Sign out
      </button>
    </nav>
  );
}

export default AdminMobileNavOverlay;
